import { render, staticRenderFns } from "./ReactMountAnalytics.vue?vue&type=template&id=3934fc57"
import script from "./ReactMountAnalytics.vue?vue&type=script&lang=ts"
export * from "./ReactMountAnalytics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3934fc57')) {
      api.createRecord('3934fc57', component.options)
    } else {
      api.reload('3934fc57', component.options)
    }
    module.hot.accept("./ReactMountAnalytics.vue?vue&type=template&id=3934fc57", function () {
      api.rerender('3934fc57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountAnalytics.vue"
export default component.exports